<template>
    
    <div class="content">
        <div class="header">
            <div class="search">
                <span class="title">时间</span>
                <el-date-picker
                    size="small"
                    v-model="value1"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-button size="small" type="primary" @click="getTrainList()">查询</el-button>
            </div>
            <el-button type="primary" size="small" @click="addVisible = true">添加任务</el-button>
        </div>
        <div>
            <el-table border style="width: 100%" :data="trainList" :row-class-name="tableRowClassName">
              <el-table-column
                align="center"
                prop="title"
                label="训练名称"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="teacher"
                label="老师"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="mode"
                label="训练类型"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="product"
                label="训练项目"
                width="140"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="info"
                label="训练介绍"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="start_time_str"
                label="开始时间"
                width="140"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="end_time_str"
                label="结束时间"
                width="140"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="status"
                label="状态"
                width="140"
              ></el-table-column>
              <el-table-column align="center" label="操作"  width="280">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="detail(scope.row)">
                            <i class="el-icon-document"></i> 详情
                        </el-button>
                        <el-button size="mini" type="danger" plain @click="delTrain(scope.row.id)">
                            删除
                        </el-button>
                        <el-button size="small" v-if="scope.row.is_train" type="warning" @click="print(scope.row.id)">打 印</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="8"
            @current-change="changePage"
            style="padding:10px 0"
            >
            </el-pagination>
        </div>

        <!-- 添加训练任务 -->
        <el-dialog title="添加训练任务" :append-to-body="true" :visible.sync="addVisible" width="500px">
            <el-form :model="add_form">
                <el-form-item label="训练名称" >
                <el-input v-model="add_form.title" autocomplete="off" placeholder="请输入训练名称"></el-input>
                </el-form-item>
                <el-form-item label="训练类型" >
                    <el-select class="w-100" v-model="add_form.mode" placeholder="请选择类型">
                        <el-option label="每日打卡" value="0"></el-option>
                        <el-option label="单次竞技" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="训练项目" >
                    <div class="product-train">
                        <el-select class="w-100" v-model="add_form.product" placeholder="请选择训练项目">
                            <el-option label="定时跳" value="0"></el-option>
                            <el-option label="定数跳" value="1"></el-option>
                        </el-select>
                        <el-select class="w-100" v-if="add_form.product==0" v-model="add_form.product_time" placeholder="请选择跳绳时长">
                            <el-option label="00:30" value="30"></el-option>
                            <el-option label="01:00" value="60"></el-option>
                            <el-option label="01:30" value="90"></el-option>
                            <el-option label="02:00" value="120"></el-option>
                        </el-select>
                        <el-select class="w-100" v-else v-model="add_form.product_num" placeholder="请选择跳绳个数">
                            <el-option label="30个" value="30"></el-option>
                            <el-option label="100个" value="100"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="训练介绍" >
                <el-input v-model="add_form.info" autocomplete="off" placeholder="请输入训练介绍"></el-input>
                </el-form-item>
                <el-form-item label="开始时间" >
                    <el-date-picker
                        class="w-100"
                        v-model="add_form.start_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="expireTimeOption"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" v-if="add_form.mode == 0">
                    <el-date-picker
                        class="w-100"
                        v-model="add_form.end_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="expireTimeOption"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="confirmAdd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 打印 -->
        <printTable v-show="false" ref="printchild"></printTable>
    </div>
    
</template>
    
<script>
import { trainList,trainSave,trainDel,trainRankDetail } from '@/api/train'
import { dateFormat } from '@/utilities/util'
import { mapState } from 'vuex'
import printTable from '@/views/tiaoshnegbisai/components/printTable'
export default {
    components:{printTable},
    data(){
        return{
            value1:'', // 搜索时间
            trainList:[],
            pageIndex:1,
            total:0,//总数
            addVisible:false,
            add_form:{
                title:'',
                type:1,
                mode:'',
                product:'',
                product_time:'',
                product_num:'',
                info:'',
                start_time:'',
                end_time:'',
                mode_num:1
            },
            //设置失效日期今天之前的日期不可选
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.system.userInfo,
            default_class: state => state.system.default_class
        }),
    },
    created(){
        this.getTrainList()
    },
    methods:{
        print(id){
            console.log('打印id',id)
            trainRankDetail({id:id,school_id:this.default_class.school_id,class_type:this.default_class.class_type}).then(res=>{
                if(res.data.length > 0){
                    this.$refs.printchild.CreateOneFormPage(res.data)
                }else{
                    this.$message.error("没有数据")
                }
                
            })
        },
        changePage(e){
            console.log(e)
            this.pageIndex = e
            this.getTrainList()
        },
        getTrainList(){
            let now_time = Date.now();
            trainList({class_id:this.default_class.id,date:this.value1,page:this.pageIndex}).then(res=>{
                this.total = res.data.total
                this.trainList = res.data.data.map(item=>{
                    let start_time = parseInt(item.start_time+'000');
                    let end_time = parseInt(item.end_time+'000');
                    let status = '未开始'
                    if(now_time >= end_time){
                        // 过期
                        status = '已过期';
                    }else if(now_time > start_time && now_time < end_time){
                        //进行中
                        status = '进行中';
                    }
                    return {
                        id:item.id,
                        title:item.title,
                        teacher:item.teacher.user_nickname,
                        mode:item.mode_text,
                        product:item.product_text+':'+ (item.product?item.product_num+'个':item.product_time+'秒'),
                        start_time:item.start_time,
                        end_time:item.end_time,
                        is_train:item.is_train,
                        start_time_str:dateFormat(item.start_time,"Y-m-d"),
                        end_time_str:dateFormat(item.end_time,"Y-m-d"),
                        train_num:item.train_num,
                        info:item.info,
                        status:status
                    }
                })
            })
        },
        tableRowClassName({row, rowIndex}) {
            let now_time = Date.now();
            let start_time = parseInt(row.start_time+'000');
            let end_time = parseInt(row.end_time+'000');
            console.log(rowIndex)
            if(now_time >= end_time){
                // 过期
                return 'warning-row';
            }else if(now_time > start_time && now_time < end_time){
                //进行中
                return 'success-row';
            }

            //未到
            return '';
        },
        confirmAdd(){
            console.log('添加了', this.add_form)
            let data = this.add_form
            if(data.title.length == 0){
                this.$message.error("请输入训练名称")
                return false
            }
            if(data.mode === ""){
                this.$message.error("请选择训练类型")
                return false
            }
            if(data.product == ""){
                this.$message.error("请选择训练项目")
                return false
            }
            if(data.product == 0 && data.product.product_time === ''){
                this.$message.error("请选择跳绳时长")
                return false
            }
            if(data.product == 1 && data.product.product_num === ''){
                this.$message.error("请选择跳绳个数")
                return false
            }
            if(data.start_time === ''){
                this.$message.error("请选择开始时间")
                return false
            }
            if(data.mode == 0){
                if(data.end_time === ''){
                    this.$message.error("请选择结束时间")
                    return false
                }
                if(data.start_time > data.end_time){
                    this.$message.error("开始时间不可大于结束时间")
                    return false
                }
            }
            data.class_id = this.default_class.id
            data.teacher_id = this.userInfo.id
            trainSave(data).then(res=>{
               if(res.code == 1){
                    this.addVisible = false
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.add_form = {
                        title:'',
                        type:1,
                        mode:'',
                        product:'',
                        product_time:'',
                        product_num:'',
                        info:'',
                        start_time:'',
                        end_time:'',
                        mode_num:1
                    }
                    this.getTrainList()
               }else{
                    this.$message({
                        type: 'info',
                        message: res.msg
                    });   
               }
            })
        },
        detail(item){
            this.$router.push({path:'/jsgs/xinliandetail',query:{rank_id:item.id,status:item.status}})
            // this.$router.push({
            //     name:'studentrank',
            //     params:{
            //         rank_id:id
            //     }
            // });
        },
        delTrain(id){
            trainDel(id).then(res=>{
                console.log(res)
                if(res.code == 1){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getTrainList()
                }else{
                    this.$message({
                        type: 'info',
                        message: res.msg
                    });  
                }
            })
        }
    }
}
</script>

<style>
.el-table .warning-row {
    background: rgb(221, 221, 221);
  }

  .el-table .success-row {
    background: #dcffc9;
  }
</style>
<style lang="scss" scoped>
    .product-train {display: flex; }
    .product-train .el-select:nth-child(1) {
        margin-right:10px;
    }
.content{
    width:100%;
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search{
            padding:20px 0;
            background:#fff;
            display:flex;
            align-items:center;
            .title{
                color:#000;
                padding-right:10px;
            }
            button{
                margin-left:10px;
            }
        }
    }
    
    .table{
        width:100%;
        display:flex;
        align-items:center;
        padding-top:50px;
        justify-content:center;
    }
}
</style>
